import type { Role, User } from "@/domains/auth/api/types";

export const SEED_USERS: ReadonlyArray<User> = [
  {
    id: "u-maarten",
    firstName: "Maarten",
    lastName: "Hendrickx",
    email: "maarten.hendrickx@police.belgium.eu",
    phone: "+32 471 12 34 56",
    role: "requester",
    service: "Wijkteam Antwerpen-Noord",
    organisation: "Politiezone Antwerpen",
    avatarColor: "bg-info-500",
  },
  {
    id: "u-lien",
    firstName: "Lien",
    lastName: "Vandevelde",
    email: "lien.vandevelde@police.belgium.eu",
    phone: "+32 471 23 45 67",
    role: "manager",
    service: "Team functionele ondersteuning",
    organisation: "Politiezone Antwerpen",
    avatarColor: "bg-primary-500",
  },
  {
    id: "u-jeroen",
    firstName: "Jeroen",
    lastName: "Vermeer",
    email: "jeroen@vermeer-camerasystemen.be",
    phone: "+32 472 34 56 78",
    role: "partner",
    service: "Plaatsingstechnieker",
    organisation: "Vermeer Mobiele Camerasystemen BV",
    avatarColor: "bg-warning-500",
  },
];

export function findUserById(id: string): User | undefined {
  return SEED_USERS.find((u) => u.id === id);
}

export function findUserByRole(role: Role): User | undefined {
  return SEED_USERS.find((u) => u.role === role);
}
